import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="flex items-center">
      <img
        src="/assets/images/logo.webp"
        alt="Josh Hastings Marketing Strategy"
        title="Josh Hastings Marketing Strategy"
        className="h-10 md:h-11 w-auto object-contain"
      />
    </Link>
  );
}
